import { CvsFeeScheduleType, useGetCvsFeeSchedulesQuery } from '../../types';

export interface UseCvsFeeScheduleQueriesResult {
  rows: CvsFeeScheduleType[];
  loading: boolean;
  hasError: boolean;
}

const EMPTY_ROWS: CvsFeeScheduleType[] = [];

export const useCvsFeeScheduleQueries = (): UseCvsFeeScheduleQueriesResult => {
  const { data, loading, error } = useGetCvsFeeSchedulesQuery();

  return {
    rows: data?.getCvsFeeSchedules ?? EMPTY_ROWS,
    loading,
    hasError: !!error,
  };
};
